import React, { Component } from "react"
import PropTypes from "prop-types"
import { List } from "immutable"
import { Row, Col, Button } from "react-bootstrap"
import InfiniteScroll from "react-infinite-scroller"

import SegueLink from "app/static/frontend/middleware/SegueLink"
import LoadingSpinner from "components/LoadingSpinner"
import { isFeatureEnabled } from "shared/featureflags/helperFunctions"
import { EmptyState, Button as QButton } from "quorumdesign"
import { MobileEmptyState } from "app/static/frontend/search-new/components/ListView/MobileEmptyState"

export default class ListView extends Component {
    static propTypes = {
        // from containers/listview/index
        currentCount: PropTypes.number,
        currentData: PropTypes.object,
        currentFilters: PropTypes.object,
        isLoading: PropTypes.bool.isRequired,
        isLoadingMore: PropTypes.bool.isRequired,
        // from shared/search/components/listview
        loadMoreData: PropTypes.func.isRequired,
        refreshData: PropTypes.func.isRequired,
        isRefreshing: PropTypes.bool.isRequired,
        shouldShowSpinner: PropTypes.bool.isRequired,
        hasNoResults: PropTypes.bool.isRequired,
        noResultsDetails: PropTypes.object,
        reachedEndOfData: PropTypes.bool.isRequired,
        // from filterablelistview
        inlineComponent: PropTypes.func.isRequired,
        resource: PropTypes.object.isRequired,
        uniqueFlvId: PropTypes.string.isRequired,
        isProfile: PropTypes.bool,
        // searchify
        isBulkActions: PropTypes.bool,
        isSearchify: PropTypes.bool,
    }

    static defaultProps = {
        currentData: List(),
        isBulkActions: false,
        isSearchify: false,
        isProfile: false,
    }

    // preserve the state spinner showing on creation, so we
    // can see if we need to fade in.
    state = { hasNoResults: this.props.hasNoResults }

    renderInlines() {
        const InlineComponent = this.props.inlineComponent

        return this.props.currentData.map((item, index) => (
            <InlineComponent
                datum={item}
                index={index}
                isProfile={this.props.isProfile}
                key={item.get("id")}
                resource={this.props.resource}
                uniqueFlvId={this.props.uniqueFlvId}
            />
        ))
    }

    renderNoObjectsInfo() {
        return this.props.isMobile ? (
            <MobileEmptyState />
        ) : isFeatureEnabled("ff_additional_emptystates") ? (
            <div className="emptystate-no-results">
                <EmptyState empty_state_paragraph={this.props.noResultsDetails.text} icon="search" iconFamily="fad">
                    {this.props.noResultsDetails.buttons.map((button) =>
                        button.link ? (
                            <SegueLink to={button.link} key={button.text}>
                                <Button variant="default">{button.text}</Button>
                            </SegueLink>
                        ) : (
                            <QButton key={button.text} text={button.text} onClick={button.action} />
                        ),
                    )}
                </EmptyState>
            </div>
        ) : (
            <div>
                <Row className="list-view no-results">
                    <Col lg={3} />
                    <Col lg={6} className="no-results-text text-center">
                        <Row className="text-center">
                            <i className="fa fa-fw fa-exclamation-triangle" />
                        </Row>
                        <Row className="text-center no-results-text-row">No results.</Row>
                        <Row className="text-center no-results-explanation">{this.props.noResultsDetails.text}</Row>
                        {this.renderNoResultsActionButtons()}
                    </Col>
                    <Col lg={3} />
                </Row>
            </div>
        )
    }

    static renderNoResultsButton(buttonDetail, numButtons) {
        const colWidth = 12 / numButtons
        return (
            <Col lg={colWidth} key={buttonDetail.text}>
                {buttonDetail.link ? (
                    <SegueLink to={buttonDetail.link} optionalPreSegueFunction={buttonDetail.action}>
                        <Button variant="default">{buttonDetail.text}</Button>
                    </SegueLink>
                ) : (
                    <Button onClick={buttonDetail.action} variant="default">
                        {buttonDetail.text}
                    </Button>
                )}
            </Col>
        )
    }

    renderNoResultsActionButtons() {
        const buttons = this.props.noResultsDetails.buttons.map((button) =>
            ListView.renderNoResultsButton(button, this.props.noResultsDetails.buttons.length),
        )

        return <Row> {buttons} </Row>
    }

    render() {
        if (this.props.shouldShowSpinner) {
            // this means that it's loading something new!
            return <LoadingSpinner id="search-spinner" />
        } else if (this.props.hasNoResults) {
            // this means that there's no data!
            return this.renderNoObjectsInfo()
        } else {
            // this means that there's data!
            return (
                <InfiniteScroll
                    data-cy="list-view-results"
                    loadMore={this.props.loadMoreData}
                    hasMore={this.props.currentData.size < this.props.currentCount}
                    initialLoad={false}
                    useWindow={false}
                    className="list-view list-view-results"
                    threshold={750}
                    style={this.props.isMobile && this.props.isSearchify ? { padding: "0 1rem 0.75rem" } : null}
                >
                    {this.renderInlines()}
                </InfiniteScroll>
            )
        }
    }
}
